module.exports = __webpack_public_path__ + "static/media/contentIntroduction3.fdc08a5a.png";